import React from 'react';
import { BrowserRouter} from 'react-router-dom';
import { Grid } from '@mui/material';
import SidebarMenu from './SidebarMenu';
import MobileMenu from './MobileMenu';
import Title from './Title';
import Content from './Content';
import BreadCrumbs from './BreadCrumbs';
import Paging from './Paging';
import Navigation from './Navigation';
import styled from 'styled-components';

const StyledGridHeader = styled(Grid)`
  display: flex;
  z-index: 10;

  @media only screen and (max-width: 1170px) {
    flex-direction: column;
  }
`

const Book = ({data}) => {
  const bookData = data.book_data;

  return (
    <>
      <Grid container className="page-container">
        <a className={'menuDashboardLinkRightTop'} href="/user">Terug naar dashboard</a>

        <BrowserRouter forceRefresh={true}>
          <MobileMenu data={bookData} />
        </BrowserRouter>

        <StyledGridHeader
          container
          alignItems="center"
          className={'header'}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <BreadCrumbs data={bookData} />
          <Paging data={bookData} />
        </StyledGridHeader>

        <Grid item xs={12} className={'page-content'}>
          <Grid item xs={12}>
            <Title data={bookData} />
          </Grid>
          <Grid item xs={12}>
            <Content data={bookData} />
          </Grid>
        </Grid>

        <Navigation data={bookData} />
      </Grid>

      <BrowserRouter forceRefresh={true}>
        <SidebarMenu data={bookData} />
      </BrowserRouter>
    </>
  )
}

export default Book
